import { AsyncPipe } from '@angular/common';
import { Component } from '@angular/core';
import { Location } from '@era/locations-sdk';
import { CategoryStoreSelectors, LocationsRouterStoreSelectors, RouterStoreStates } from '@era/stores';
import { Store } from '@ngrx/store';
import { SelectLocationListComponent } from '@rocksoft/cdk';
import { Observable } from 'rxjs';

@Component({
  selector: 'era-select-location-list-devices',
  templateUrl: './select-location-list-devices.container.html',
  styleUrls: ['./select-location-list-devices.container.scss'],
  imports: [SelectLocationListComponent, AsyncPipe],
})
export class SelectLocationListDevicesContainerComponent {
  public readonly locations$: Observable<Location[]>;
  public readonly location$: Observable<Location>;

  constructor(
    private readonly locationStore: Store<Location>,
    private readonly routerStore: Store<RouterStoreStates.RouterState>
  ) {
    this.locations$ = this.locationStore.select(CategoryStoreSelectors.selectAllCategoryEntitiesByType('Location'));
    this.location$ = this.routerStore.select(LocationsRouterStoreSelectors.selectLocation);
  }
}
